export enum FlexWrapOption {
    Wrap = 'wrap',
    WrapReverse = 'wrap-reverse',
    Nowrap = 'nowrap'
}
